import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';
import ServiceSheetModal from '@/components/common/ServiceSheetModal';

interface ServiceHeroProps {
  service: {
    title: string;
    subtitle: string;
    description: string;
    icon: string;
    category: string;
  };
}

const ServiceHero = ({ service }: ServiceHeroProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-transparent"></div>
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
              <Icon name={service.icon as any} size={20} className="text-primary" />
              <span className="text-sm font-semibold text-primary">{service.category}</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-foreground mb-6">
              {service.title}
            </h1>
            
            <p className="text-xl sm:text-2xl text-primary font-semibold mb-6">
              {service.subtitle}
            </p>
            
            <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              {service.description}
            </p>
            
            <div className="flex flex-wrap items-center justify-center gap-4 mt-10">
              <Link
                href="/contact"
                className="px-8 py-4 rounded-lg font-semibold bg-cta text-cta-foreground hover:bg-cta/90 transition-all duration-300 shadow-silver-glow hover:shadow-orange-glow-hover hover:-translate-y-1 flex items-center space-x-2 button-3d"
              >
                <span>Demo boeken</span>
                <Icon name="ArrowRightIcon" size={20} />
              </Link>
              <button
                onClick={() => setShowModal(true)}
                className="px-8 py-4 rounded-lg font-semibold border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-silver-glow hover:shadow-orange-glow-hover flex items-center space-x-2 card-3d-glow"
              >
                <Icon name="DocumentTextIcon" size={20} />
                <span>Download service sheet</span>
              </button>
            </div>
          </div>
        </div>
        
        <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
      </section>
      
      {showModal && (
        <ServiceSheetModal
          serviceName={service.title}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ServiceHero;